module.exports = {"520122100":"永靖镇","520122101":"温泉镇","520122102":"九庄镇","520122103":"小寨坝镇","520122104":"西山镇","520122105":"养龙司镇","520122106":"石硐镇","520122107":"鹿窝镇","520122108":"流长镇","520122200":"青山苗族乡","520122400":"新华社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520122.json
// module id = 2268
// module chunks = 0